import type maplibregl from "maplibre-gl";
import type { ExpressionStyleDefinition } from "@designboticteam/map";
import { buildStateExpression } from "../expressionBuilders/buildStateExpression";

function createStyleExpressionFillLayer({
	sourceId,
	sourceLayerId,
	attribute,
	idle,
	hover,
	isVisible,
}: {
	sourceId: string;
	sourceLayerId: string;
	attribute: string;
	idle: ExpressionStyleDefinition;
	hover: ExpressionStyleDefinition;
	isVisible: boolean;
}): maplibregl.AddLayerObject {
	return {
		id: `${sourceId}__fill`,
		source: sourceId,
		"source-layer": sourceLayerId,
		type: "fill",
		paint: {
			"fill-color": buildStateExpression({
				expression: {
					attribute,
					idle: {
						cases: Object.entries(idle.cases).flatMap(([caseName, styleDefinition]) => {
							return styleDefinition.fill === undefined ? [] : [[caseName, styleDefinition.fill.color]];
						}),
						fallback: idle.fallback?.fill?.color ?? "#000000",
					},
					hover: {
						cases: Object.entries(hover.cases).flatMap(([caseName, styleDefinition]) => {
							return styleDefinition.fill === undefined ? [] : [[caseName, styleDefinition.fill.color]];
						}),
						fallback: hover.fallback?.fill?.color ?? "#000000",
					},
				},
			}),
			"fill-opacity": buildStateExpression({
				globalStateModifierKey: `opacity__${sourceId}`,
				expression: {
					attribute,
					idle: {
						cases: Object.entries(idle.cases).flatMap(([caseName, styleDefinition]) => {
							return styleDefinition.fill === undefined ? [] : [[caseName, styleDefinition.fill.opacity ?? 1]];
						}),
						fallback: idle.fallback?.fill?.opacity ?? 1,
					},
					hover: {
						cases: Object.entries(hover.cases).flatMap(([caseName, styleDefinition]) => {
							return styleDefinition.fill === undefined ? [] : [[caseName, styleDefinition.fill.opacity ?? 1]];
						}),
						fallback: hover.fallback?.fill?.opacity ?? 1,
					},
				},
			}),
		},
		layout: { visibility: isVisible ? "visible" : "none" },
	};
}

export { createStyleExpressionFillLayer };
